module.exports = {"371472005":"运河街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371472.json
// module id = 1482
// module chunks = 0